
// import React, { useState, useEffect } from "react";
// import { logApi } from "../../api/Api";

// const LtSvg = ({ svgColor }) => {
//   const [logData, setLogData] = useState(null);

//   const [credentials, setCredentials] = useState({
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//   });

//   const fetchLogData = async () => {
//     try {
//       const res = await logApi(credentials);
//       if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//         setLogData(res.TOT_LIVE_KW_NEW[0]);
//       } else {
//         setLogData(null);
//       }
//     } catch (error) {
//       console.error("Error fetching log data:", error);
//       setLogData(null);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, [credentials]);

//   const solarColor =
//     logData?.SOLAR == null
//       ? "gray"
//       : logData.SOLAR <= 0
//         ? "red"
//         : "green";

//   const loadColor =
//     logData?.TOTAL_LOAD == null
//       ? "gray"
//       : logData.TOTAL_LOAD <= 0
//         ? "red"
//         : "green";

//   const dgColor =
//     logData?.GenSet == null
//       ? "gray"
//       : logData.GenSet <= 0
//         ? "red"
//         : "green";


//   const arrowColor =
//     logData?.PLANT_STATUS?.toLowerCase() === "plant online"
//       ? "#135DD8"
//       : logData?.PLANT_STATUS?.toLowerCase() === "plant offline"
//         ? "gray"
//         : "black";



//   return (
//     <div>
//       <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
//         width="100%" height="17rem" viewBox="0 0 400.000000 430.000000"
//         preserveAspectRatio="xMidYMid meet">

//         <g transform="translate(-620.000000,1560.000000) scale(0.100000,-0.100000)"
//           fill="#000000" stroke="none">

//           <path d="M6475 15207 c-9 -22 -2 -62 10 -60 6 1 11 14 13 29 4 32 -14 56 -23
// 31z" fill="orange" />
//           <path d="M6320 15170 c0 -20 24 -60 37 -60 17 0 17 20 -3 48 -16 23 -34 29
// -34 12z" fill="orange" />
//           <path d="M6615 15150 c-19 -36 -19 -40 0 -40 16 0 35 30 35 54 0 26 -18 18
// -35 -14z" fill="orange" />
//           <path d="M6414 15066 c-44 -20 -93 -75 -100 -113 -3 -18 -7 -34 -8 -35 0 -1
// -106 -5 -234 -8 l-233 -5 -40 -95 c-22 -52 -62 -147 -90 -210 -54 -127 -56
// -137 -34 -185 24 -50 47 -55 236 -55 l170 0 -3 -57 -3 -58 -45 -3 c-55 -4 -80
// -25 -80 -67 0 -61 15 -65 222 -65 166 0 187 2 201 18 22 24 22 75 -1 95 -9 8
// -37 17 -62 19 l-45 3 -3 58 -3 57 164 0 c91 0 178 5 195 11 31 10 62 58 62 95
// 0 10 -22 70 -50 135 -27 64 -50 123 -50 129 0 7 12 21 26 33 33 26 64 91 64
// 137 0 50 -32 113 -74 145 -43 33 -133 44 -182 21z m156 -41 c61 -45 84 -116
// 59 -182 -11 -30 -47 -73 -61 -73 -5 0 -23 30 -40 68 -17 37 -35 70 -42 74 -6
// 4 -41 8 -78 8 -60 0 -68 2 -68 19 0 10 10 31 22 46 54 69 145 86 208 40z
// m-646 -172 c-20 -81 -18 -78 -60 -78 -43 0 -45 6 -19 70 13 31 20 35 50 35 34
// 0 35 -1 29 -27z m128 -28 l-15 -55 -42 0 c-23 0 -44 3 -47 6 -5 5 3 50 17 92
// 3 7 23 12 53 12 l49 0 -15 -55z m98 0 l0 -55 -36 0 -36 0 7 48 c9 59 11 62 41
// 62 23 0 24 -3 24 -55z m93 48 c3 -5 8 -29 12 -55 l7 -48 -36 0 -36 0 0 55 c0
// 52 1 55 24 55 14 0 27 -3 29 -7z m136 -15 c5 -13 12 -38 16 -55 l7 -33 -50 0
// c-54 0 -51 -2 -72 78 l-8 32 49 0 c42 0 51 -3 58 -22z m120 -27 c11 -27 21
// -53 21 -56 0 -3 -19 -5 -41 -3 -40 3 -42 5 -55 48 -18 61 -19 60 20 60 31 0
// 35 -4 55 -49z m-609 -105 c0 -7 -5 -27 -11 -45 -10 -29 -14 -31 -61 -31 -47 0
// -49 1 -43 23 16 51 34 67 75 67 27 0 40 -4 40 -14z m140 0 c0 -7 -3 -28 -6
// -45 -6 -30 -7 -31 -65 -31 -63 0 -61 -3 -37 63 9 24 15 27 59 27 35 0 49 -4
// 49 -14z m120 -31 l0 -45 -50 0 c-50 0 -50 0 -44 28 14 62 14 62 55 62 l39 0 0
// -45z m126 18 c3 -16 8 -36 11 -45 4 -15 -3 -18 -46 -18 l-51 0 0 45 0 45 40 0
// c35 0 40 -3 46 -27z m148 -13 c9 -22 16 -43 16 -45 0 -3 -27 -5 -60 -5 -44 0
// -60 4 -60 14 0 7 -3 28 -6 45 l-6 31 50 0 c49 0 50 -1 66 -40z m126 8 c30 -50
// 26 -58 -29 -58 -46 0 -50 2 -60 31 -18 52 -15 59 29 59 35 0 43 -5 60 -32z
// m-700 -105 c0 -10 -5 -35 -11 -55 l-10 -38 -59 0 c-33 0 -60 2 -60 5 0 11 31
// 79 41 92 7 7 31 13 55 13 35 0 44 -3 44 -17z m153 -3 c-1 -8 -6 -31 -10 -50
// -9 -35 -9 -35 -67 -38 l-58 -3 7 38 c12 67 20 74 78 71 39 -2 51 -7 50 -18z
// m147 -35 l0 -55 -66 0 -66 0 7 43 c10 58 20 67 76 67 l49 0 0 -55z m148 43 c5
// -7 13 -32 17 -55 l7 -43 -66 0 -66 0 0 55 0 55 49 0 c27 0 53 -6 59 -12z m151
// -6 c5 -9 12 -34 16 -55 l7 -38 -58 3 -59 3 -11 45 c-6 25 -9 48 -7 53 2 4 26
// 7 53 7 37 0 52 -4 59 -18z m159 -32 c12 -28 22 -52 22 -55 0 -3 -27 -5 -60 -5
// l-59 0 -10 38 c-19 67 -17 72 37 72 l48 0 22 -50z m32 -124 c0 -55 -6 -56
// -474 -56 -386 0 -431 2 -448 17 -10 9 -18 27 -18 40 l0 23 470 0 470 0 0 -24z
// m-420 -141 l0 -55 -50 0 -50 0 0 55 0 55 50 0 50 0 0 -55z m139 -113 c6 -11 6
// -24 0 -35 -9 -15 -30 -17 -189 -17 -159 0 -180 2 -189 17 -6 11 -6 24 0 35 9
// 16 27 18 189 18 162 0 180 -2 189 -18z" fill="" />
//           <path d="M6214 15059 c-7 -13 35 -50 50 -46 22 7 15 27 -13 41 -21 12 -32 13
// -37 5z" fill="orange" />
//           <path d="M6716 15049 c-19 -15 -24 -25 -17 -32 13 -13 61 17 61 38 0 21 -13
// 19 -44 -6z" fill="orange" />
//           <path d="M6732 14898 c5 -15 67 -18 71 -3 1 6 -15 11 -37 13 -28 3 -37 0 -34
// -10z" fill="orange" />
//           <path d="M6695 14770 c-5 -8 43 -40 60 -40 14 0 3 30 -14 40 -24 13 -38 13
// -46 0z" fill="orange" />
//           <path d="M7730 15026 c0 -19 -4 -38 -10 -41 -6 -4 -10 -165 -10 -451 0 -437 0
// -444 20 -444 11 0 20 -7 20 -15 0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 9 15 20
// 15 11 0 20 -7 20 -15 0 -8 7 -15 15 -15 9 0 18 7 21 15 5 13 48 15 300 15
// l294 0 0 444 c0 286 -4 447 -10 451 -5 3 -10 22 -10 41 l0 34 -345 0 -345 0 0
// -34z m670 -21 c0 -21 -5 -25 -30 -25 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11
// 0 -20 -4 -20 -10 0 -6 -82 -10 -225 -10 -143 0 -225 4 -225 10 0 6 -9 10 -20
// 10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30 -10 -25 0 -30 4 -30 25 l0 25 325 0
// 325 0 0 -25z m8 -407 l2 -358 -335 0 -335 0 0 353 c0 195 3 357 7 360 4 4 153
// 6 332 5 l326 -3 3 -357z m2 -433 l0 -35 -335 0 -335 0 0 28 c0 16 3 32 7 35 3
// 4 154 7 335 7 l328 0 0 -35z" />
//           <path d="M7777 14914 c-16 -17 -5 -25 31 -22 20 2 37 8 37 13 0 12 -57 19 -68
// 9z"/>
//           <path d="M7890 14764 c0 -113 3 -149 14 -160 44 -43 298 -43 342 0 11 11 14
// 47 14 160 l0 146 -185 0 -185 0 0 -146z m348 -16 l-3 -121 -65 -19 c-36 -10
// -78 -18 -95 -18 -16 0 -59 8 -95 18 l-65 19 -3 121 -3 122 166 0 166 0 -3
// -122z" />
//           <path d="M7950 14785 l0 -55 125 0 125 0 0 55 0 55 -125 0 -125 0 0 -55z m210
// 10 c0 -25 -1 -25 -85 -25 -84 0 -85 0 -85 25 0 25 1 25 85 25 84 0 85 0 85
// -25z" />
//           <path d="M7950 14670 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10
// -11 0 -20 -4 -20 -10z" />
//           <path d="M8020 14670 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10
// -11 0 -20 -4 -20 -10z" />
//           <path d="M8090 14670 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10
// -11 0 -20 -4 -20 -10z"/>
//           <path d="M8160 14670 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10
// -11 0 -20 -4 -20 -10z" />
//           <path d="M7860 14509 c-47 -55 -47 -59 -9 -59 l32 0 -22 -23 c-18 -20 -19 -26
// -8 -35 15 -13 21 -8 65 56 l23 32 -26 0 c-22 0 -24 3 -15 19 12 23 13 51 3 51
// -5 0 -24 -19 -43 -41z" />
//           <path d="M8130 14330 l0 -60 125 0 125 0 0 60 0 60 -125 0 -125 0 0 -60z m210
// -5 l0 -36 -87 3 -88 3 -3 33 -3 32 90 0 91 0 0 -35z" />
//           <path d="M7770 14345 c0 -13 24 -15 160 -15 136 0 160 2 160 15 0 13 -24 15
// -160 15 -136 0 -160 -2 -160 -15z" />
//           <path d="M7770 14280 c0 -6 40 -10 100 -10 60 0 100 4 100 10 0 6 -40 10 -100
// 10 -60 0 -100 -4 -100 -10z" />
//           <path d="M9422 14908 c-9 -9 -12 -94 -12 -323 0 -229 3 -314 12 -323 17 -17
// 589 -17 606 0 17 17 17 629 0 646 -9 9 -90 12 -303 12 -213 0 -294 -3 -303
// -12z m516 -230 l3 -138 -216 0 -215 0 0 133 c0 74 3 137 7 141 4 3 99 5 212 4
// l206 -3 3 -137z" />
//           <path d="M9540 14740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z" />
//           <path d="M9620 14740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z" />
//           <path d="M9700 14740 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 -2 40 -25 40
// -22 0 -25 -4 -25 -40z"/>
//           <path d="M9770 14740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M9850 14740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M9540 14630 c0 -19 7 -20 186 -20 121 0 183 3 179 10 -4 6 -72 11
// -163 12 l-157 2 165 6 165 6 -187 2 c-182 2 -188 1 -188 -18z" />
//           <path d="M9716 14573 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z" />

//           {/* right long arrow */}
//           <path d="M10530 14708 c0 -6 10 -22 22 -35 l21 -23 -211 0 -212 0 0 -25 0 -25
// 217 0 217 0 -27 -28 c-26 -27 -35 -52 -19 -52 4 0 26 18 47 40 39 40 41 41
// 105 38 l65 -3 3 -514 2 -515 -28 27 c-27 26 -52 35 -52 19 0 -4 18 -26 40 -47
// l40 -39 0 -443 0 -443 -237 0 -237 0 27 28 c26 27 35 52 19 52 -4 0 -30 -22
// -57 -50 l-49 -50 49 -50 c27 -27 53 -50 57 -50 15 0 8 24 -14 48 l-23 24 258
// -4 257 -3 0 476 0 475 35 34 c19 19 35 38 35 42 0 15 -24 8 -47 -14 l-23 -21
// 0 536 0 537 -98 0 -98 0 -34 35 c-35 36 -50 43 -50 23z" fill={arrowColor} />

//           <path d="M8513 14564 c-3 -8 -1 -20 4 -25 5 -5 173 -8 424 -7 406 3 414 3 414
// 23 0 20 -8 20 -418 23 -373 2 -418 1 -424 -14z" fill={arrowColor} />
//           <path d="M6980 14505 l0 -25 333 2 c324 3 332 3 332 23 0 20 -8 20 -332 23
// l-333 2 0 -25z" fill={arrowColor} />


//           <path d="M9560 14205 c0 -23 3 -25 50 -25 47 0 50 2 50 25 0 23 -3 25 -50 25
// -47 0 -50 -2 -50 -25z" />
//           <path d="M9670 14205 c0 -24 3 -25 55 -25 52 0 55 1 55 25 0 24 -3 25 -55 25
// -52 0 -55 -1 -55 -25z"/>
//           <path d="M9790 14205 c0 -23 3 -25 50 -25 47 0 50 2 50 25 0 23 -3 25 -50 25
// -47 0 -50 -2 -50 -25z" />
//           <path d="M9580 14129 c0 -38 1 -40 28 -37 23 3 27 8 30 41 3 35 2 37 -27 37
// -30 0 -31 -2 -31 -41z" />
//           <path d="M9700 14130 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 -2 40 -25 40
// -22 0 -25 -4 -25 -40z"/>
//           <path d="M9812 14133 c3 -33 7 -38 31 -41 26 -3 27 -1 27 37 0 39 -1 41 -31
// 41 -29 0 -30 -2 -27 -37z" />
//           <path d="M6129 13228 c-6 -11 -27 -66 -45 -121 -34 -100 -35 -102 -133 -201
// -106 -108 -141 -160 -121 -180 8 -8 14 -7 21 7 12 21 38 22 45 2 8 -21 21 -19
// 29 5 5 15 15 20 42 20 57 0 34 25 -27 28 l-53 3 69 70 c37 38 72 69 76 69 5 0
// 8 -42 8 -92 l-1 -93 -104 -109 c-58 -60 -105 -115 -105 -122 0 -7 -3 -19 -6
// -28 -4 -10 -1 -16 9 -16 8 0 17 9 20 20 3 11 13 20 22 20 9 0 19 -9 22 -20 3
// -11 8 -20 12 -20 3 0 12 9 19 20 8 13 23 20 42 20 17 0 30 4 30 9 0 11 -36 21
// -80 21 l-34 0 69 70 c38 39 73 70 77 70 5 0 8 -44 8 -97 0 -97 -1 -99 -67
// -270 l-68 -173 -110 -1 c-95 -2 -103 -3 -55 -9 71 -10 796 -10 875 0 54 6 49
// 7 -51 9 l-110 1 -67 168 c-66 164 -67 170 -69 265 -1 53 2 100 6 104 4 4 39
// -25 79 -65 l72 -72 -42 0 c-23 0 -48 -3 -57 -6 -26 -10 -18 -24 13 -24 18 0
// 34 -8 43 -22 l15 -22 12 22 c15 27 38 28 46 2 9 -29 25 -25 25 6 0 20 -26 53
// -105 134 l-105 108 -1 58 c-2 69 1 127 7 133 7 8 134 -122 134 -136 0 -9 -15
// -13 -44 -13 -25 0 -48 -4 -51 -10 -3 -6 5 -10 19 -10 14 0 35 -10 46 -22 20
// -21 22 -22 31 -5 12 21 35 22 43 2 9 -26 26 -17 26 14 0 24 -21 52 -110 144
// -106 111 -111 118 -144 208 -54 150 -54 149 -97 149 -29 0 -41 -5 -50 -22z
// m113 -112 c20 -57 34 -107 31 -110 -11 -11 -193 -7 -193 4 0 9 47 148 65 193
// 4 10 18 17 34 17 24 0 29 -8 63 -104z m2 -153 c3 -4 -10 -24 -31 -45 l-37 -38
// -38 37 c-21 20 -38 41 -38 45 0 10 134 11 144 1z m-124 -68 l34 -35 -42 -43
// -42 -42 0 78 c0 42 4 77 8 77 4 0 23 -16 42 -35z m170 -40 c0 -41 -3 -75 -7
// -75 -4 0 -24 17 -45 37 l-38 37 37 38 c20 21 41 38 45 38 4 0 8 -34 8 -75z
// m-73 -57 c18 -18 33 -36 33 -40 0 -4 -35 -8 -77 -8 l-77 0 39 40 c21 22 41 40
// 44 40 3 0 20 -14 38 -32z m27 -85 c7 -8 -53 -73 -68 -73 -12 0 -76 61 -76 72
// 0 10 134 11 144 1z m-127 -65 c18 -18 33 -36 33 -42 0 -12 -61 -76 -72 -76 -4
// 0 -8 34 -8 75 0 41 3 75 7 75 4 0 22 -14 40 -32z m173 -43 c0 -41 -3 -75 -7
// -75 -4 0 -24 17 -45 37 l-38 37 37 38 c20 21 41 38 45 38 4 0 8 -34 8 -75z
// m-57 -73 l47 -48 -53 -52 -53 -52 -49 50 -49 50 49 50 c27 28 52 50 55 50 3 0
// 27 -22 53 -48z m115 -204 c81 -198 81 -199 -41 -79 l-105 104 41 49 c23 26 45
// 48 48 48 4 0 29 -55 57 -122z m-237 73 l44 -38 -99 -107 c-87 -93 -116 -119
// -116 -101 0 15 113 285 120 285 4 0 27 -17 51 -39z m163 -164 c47 -43 86 -83
// 86 -88 0 -5 -79 -9 -187 -9 l-188 0 90 90 c50 50 95 89 102 88 6 -2 50 -38 97
// -81z" />
//           <path d="M9472 12938 c-9 -9 -12 -94 -12 -323 0 -229 3 -314 12 -323 17 -17
// 589 -17 606 0 17 17 17 629 0 646 -9 9 -90 12 -303 12 -213 0 -294 -3 -303
// -12z m516 -230 l3 -138 -216 0 -215 0 0 133 c0 74 3 137 7 141 4 3 99 5 212 4
// l206 -3 3 -137z" />
//           <path d="M9590 12770 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z" />
//           <path d="M9670 12770 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M9750 12770 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 -2 40 -25 40
// -22 0 -25 -4 -25 -40z"/>
//           <path d="M9820 12770 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M9900 12770 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M9590 12660 c0 -19 7 -20 186 -20 121 0 183 3 179 10 -4 6 -72 11
// -163 12 l-157 2 165 6 165 6 -187 2 c-182 2 -188 1 -188 -18z" />
//           <path d="M9766 12603 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z" />
//           <path d="M7772 12908 c-9 -9 -12 -94 -12 -323 0 -229 3 -314 12 -323 17 -17
// 589 -17 606 0 17 17 17 629 0 646 -9 9 -90 12 -303 12 -213 0 -294 -3 -303
// -12z m516 -230 l3 -138 -216 0 -215 0 0 133 c0 74 3 137 7 141 4 3 99 5 212 4
// l206 -3 3 -137z" />
//           <path d="M7890 12740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z" />
//           <path d="M7970 12740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M8050 12740 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 -2 40 -25 40
// -22 0 -25 -4 -25 -40z"/>
//           <path d="M8120 12740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M8200 12740 c0 -38 2 -40 30 -40 28 0 30 2 30 40 0 38 -2 40 -30 40
// -28 0 -30 -2 -30 -40z"/>
//           <path d="M7890 12630 c0 -19 7 -20 186 -20 121 0 183 3 179 10 -4 6 -72 11
// -163 12 l-157 2 165 6 165 6 -187 2 c-182 2 -188 1 -188 -18z"/>
//           <path d="M8066 12573 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z" />

//           {/* arrow */}
//           <path d="M6885 12590 l-49 -50 49 -50 c27 -27 53 -50 57 -50 15 0 8 24 -14 47
// l-21 23 371 0 372 0 0 25 0 25 -377 0 -377 0 27 28 c26 27 35 52 19 52 -4 0
// -30 -22 -57 -50z" fill={arrowColor} />
//           <path d="M8513 12574 c-3 -8 -1 -20 4 -25 5 -5 170 -8 414 -7 396 3 404 3 404
// 23 0 20 -8 20 -408 23 -364 2 -408 1 -414 -14z" fill={arrowColor} />


//           <path d="M9610 12235 c0 -23 3 -25 50 -25 47 0 50 2 50 25 0 23 -3 25 -50 25
// -47 0 -50 -2 -50 -25z"/>
//           <path d="M9720 12235 c0 -24 3 -25 55 -25 52 0 55 1 55 25 0 24 -3 25 -55 25
// -52 0 -55 -1 -55 -25z"/>
//           <path d="M9840 12235 c0 -23 3 -25 50 -25 47 0 50 2 50 25 0 23 -3 25 -50 25
// -47 0 -50 -2 -50 -25z"/>
//           <path d="M7910 12205 c0 -23 3 -25 50 -25 47 0 50 2 50 25 0 23 -3 25 -50 25
// -47 0 -50 -2 -50 -25z"/>
//           <path d="M8020 12205 c0 -24 3 -25 55 -25 52 0 55 1 55 25 0 24 -3 25 -55 25
// -52 0 -55 -1 -55 -25z"/>
//           <path d="M8140 12205 c0 -23 3 -25 50 -25 47 0 50 2 50 25 0 23 -3 25 -50 25
// -47 0 -50 -2 -50 -25z"/>
//           <path d="M9630 12159 c0 -38 1 -40 28 -37 23 3 27 8 30 41 3 35 2 37 -27 37
// -30 0 -31 -2 -31 -41z"/>
//           <path d="M9750 12160 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 -2 40 -25 40
// -22 0 -25 -4 -25 -40z"/>
//           <path d="M9862 12163 c3 -33 7 -38 31 -41 26 -3 27 -1 27 37 0 39 -1 41 -31
// 41 -29 0 -30 -2 -27 -37z"/>
//           <path d="M7930 12129 c0 -38 1 -40 28 -37 23 3 27 8 30 41 3 35 2 37 -27 37
// -30 0 -31 -2 -31 -41z"/>
//           <path d="M8050 12130 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 -2 40 -25 40
// -22 0 -25 -4 -25 -40z"/>
//           <path d="M8162 12133 c3 -33 7 -38 31 -41 26 -3 27 -1 27 37 0 39 -1 41 -31
// 41 -29 0 -30 -2 -27 -37z"/>
//         </g>
//       </svg>
//     </div>
//   );
// };

// export default LtSvg;



import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

const LtSvg = ({ svgColor }) => {
  const [logData, setLogData] = useState(null);

  const [credentials, setCredentials] = useState({
    LOGIN_ID: localStorage.getItem("LoginID"),
    LOC_CODE: localStorage.getItem("LCODE"),
    PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
  });

  const fetchLogData = async () => {
    try {
      const res = await logApi(credentials);
      if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
        setLogData(res.TOT_LIVE_KW_NEW[0]);
      } else {
        setLogData(null);
      }
    } catch (error) {
      console.error("Error fetching log data:", error);
      setLogData(null);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, [credentials]);

  const solarColor =
    logData?.SOLAR == null
      ? "gray"
      : logData.SOLAR <= 0
        ? "red"
        : "green";

  const loadColor =
    logData?.TOTAL_LOAD == null
      ? "gray"
      : logData.TOTAL_LOAD <= 0
        ? "red"
        : "green";

  const dgColor =
    logData?.GenSet == null
      ? "gray"
      : logData.GenSet <= 0
        ? "red"
        : "green";


  const arrowColor =
    logData?.PLANT_STATUS?.toLowerCase() === "plant online"
      ? "#135DD8"
      : logData?.PLANT_STATUS?.toLowerCase() === "plant offline"
        ? "gray"
        : "black";



  return (
    <div>
   <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="100%" height="100%" viewBox="0 0 800.000000 1689.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(-350.000000,1620.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2750 16009 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z" />
<path d="M4797 15804 c-11 -11 -8 -74 3 -74 14 0 23 46 13 65 -5 8 -12 12 -16
9z" fill="orange"/>
<path d="M4654 15759 c-8 -13 32 -56 42 -46 8 8 -15 57 -27 57 -4 0 -11 -5
-15 -11z" fill="orange"/>
<path d="M4930 15745 c-7 -14 -10 -28 -6 -32 10 -10 48 36 40 48 -9 15 -20 10
-34 -16z" fill="orange"/>
<path d="M4740 15682 c-34 -16 -80 -67 -91 -101 -7 -20 -17 -39 -23 -43 -6 -4
-104 -8 -217 -8 l-207 0 -21 -45 c-12 -25 -21 -53 -21 -62 0 -24 -32 -113 -41
-113 -4 0 -17 -26 -29 -57 -13 -32 -27 -62 -32 -67 -17 -20 -8 -84 16 -113
l24 -28 171 -3 171 -3 0 -55 0 -54 -53 0 c-60 0 -77 -12 -77 -51 0 -52 26 -59
210 -59 116 0 170 4 178 12 7 7 12 31 12 55 l0 42 -57 3 -58 3 -3 53 -3 52
160 0 c175 0 204 7 227 51 19 39 18 57 -11 116 -13 28 -27 63 -31 77 -3 14
-10 26 -14 26 -4 0 -13 14 -20 30 -12 29 -11 32 24 66 42 41 56 70 56 120 0
90 -68 156 -168 161 -32 1 -64 -1 -72 -5z m162 -48 c43 -39 61 -121 36 -167
-11 -22 -46 -52 -61 -52 -5 0 -23 27 -40 60 l-32 60 -67 3 c-38 2 -68 7 -68
13 0 24 47 98 65 103 45 10 146 -2 167 -20z m-620 -171 c-16 -44 -20 -48 -55
-51 -42 -4 -43 -2 -19 55 16 40 20 43 54 43 l38 0 -18 -47z m142 20 c-13 -60
-25 -73 -69 -73 -23 0 -44 3 -47 6 -4 3 1 25 9 50 l15 44 49 0 c49 0 49 0 43
-27z m66 -23 c0 -47 -2 -50 -25 -50 -23 0 -25 3 -25 50 0 47 2 50 25 50 23 0
25 -3 25 -50z m90 38 c0 -7 3 -30 7 -51 6 -38 5 -39 -23 -35 -27 3 -29 6 -32
51 -3 45 -2 47 22 47 15 0 26 -6 26 -12z m130 -38 l0 -50 -35 0 c-37 0 -48 12
-58 68 l-6 32 49 0 50 0 0 -50z m100 4 c11 -25 20 -48 20 -50 0 -2 -17 -4 -39
-4 -40 0 -46 7 -66 78 -6 20 -3 22 30 22 33 0 37 -4 55 -46z m-560 -96 c-1
-45 -13 -58 -51 -58 -36 0 -39 2 -39 28 0 16 3 32 7 35 12 13 83 8 83 -5z
m140 -7 c0 -43 -10 -51 -65 -51 l-53 0 11 35 c10 34 12 35 59 35 41 0 48 -3
48 -19z m100 -16 c0 -33 -2 -35 -35 -35 -36 0 -40 6 -29 48 5 16 14 22 35 22
26 0 29 -3 29 -35z m121 -2 l6 -33 -43 0 c-44 0 -44 0 -44 36 0 35 1 35 37 32
33 -3 38 -7 44 -35z m119 18 c21 -39 13 -51 -34 -51 -44 0 -55 12 -56 58 0 21
78 15 90 -7z m135 -18 l14 -33 -48 0 c-42 0 -49 3 -60 26 -16 35 -6 46 41 42
34 -3 42 -8 53 -35z m-653 -68 c3 -3 0 -25 -7 -48 -12 -42 -12 -42 -64 -45
l-52 -3 26 50 c23 46 29 51 59 51 18 0 35 -2 38 -5z m151 -25 c-7 -68 -9 -70
-73 -70 l-60 0 6 28 c18 71 20 73 76 70 50 -3 53 -5 51 -28z m127 -20 l0 -50
-56 0 c-50 0 -55 2 -49 18 4 9 9 26 12 37 3 11 6 26 9 33 2 7 20 12 44 12 l40
0 0 -50z m138 38 c6 -7 13 -30 17 -50 l7 -38 -61 0 -61 0 0 43 c0 24 3 47 7
50 11 12 80 8 91 -5z m144 -38 l16 -50 -48 0 c-27 0 -51 3 -53 8 -3 4 -8 26
-12 50 l-7 42 44 0 c44 0 44 0 60 -50z m147 5 c12 -25 21 -47 21 -50 0 -3 -27
-5 -60 -5 l-59 0 -10 38 c-17 60 -16 62 38 62 48 0 49 -1 70 -45z m31 -114 c0
-11 -7 -27 -16 -35 -13 -14 -65 -16 -412 -16 -344 0 -401 2 -420 16 -12 8 -22
24 -22 35 0 19 11 19 435 19 423 0 435 -1 435 -19z m-380 -131 l0 -50 -55 0
-55 0 0 50 0 50 55 0 55 0 0 -50z m120 -90 c12 -7 12 -13 4 -27 -10 -16 -31
-18 -177 -21 -158 -2 -166 -2 -172 18 -3 11 -3 24 0 30 8 13 325 13 345 0z"/>
<path d="M4556 15673 c-11 -12 -6 -20 19 -31 31 -14 35 -15 35 -3 0 12 -46 41
-54 34z" fill="orange"/>
<path d="M5017 15664 c-15 -8 -25 -19 -22 -24 6 -9 65 10 65 22 0 15 -16 16
-43 2z" fill="orange"/>
<path d="M7003 15543 c-4 -32 -8 -182 -8 -334 0 -240 2 -277 16 -292 13 -12
19 -13 28 -4 9 9 14 9 20 -2 7 -10 13 -10 29 -2 13 7 93 11 216 11 l196 0 0
294 c0 161 -3 314 -6 340 l-7 46 -238 0 -238 0 -8 -57z m467 13 c0 -12 -37
-14 -225 -14 -188 0 -225 2 -225 14 0 12 37 14 225 14 188 0 225 -2 225 -14z
m10 -286 l0 -250 -230 0 -230 0 0 250 0 250 230 0 230 0 0 -250z m0 -300 c0
-19 -7 -20 -230 -20 -223 0 -230 1 -230 20 0 19 7 20 230 20 223 0 230 -1 230
-20z" />
<path d="M7043 15483 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
<path d="M7120 15385 c0 -118 2 -122 80 -125 171 -7 180 0 180 135 l0 95 -130
0 -130 0 0 -105z m240 -9 l0 -84 -50 -12 c-47 -11 -133 -7 -157 8 -5 4 -13 44
-17 90 l-7 82 115 0 116 0 0 -84z" />
<path d="M7160 15400 l0 -40 90 0 90 0 0 40 0 40 -90 0 -90 0 0 -40z m140 20
c23 -15 -5 -30 -57 -30 -42 0 -60 11 -48 30 8 13 85 13 105 0z" />
<path d="M7168 15323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
<path d="M7218 15323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
<path d="M7096 15208 c-25 -32 -25 -33 -5 -36 16 -3 18 -6 8 -18 -24 -29 3
-28 29 1 20 24 22 31 10 33 -10 2 -14 11 -10 27 6 33 -2 31 -32 -7z" />
<path d="M7280 15085 l0 -45 90 0 90 0 0 45 0 45 -90 0 -90 0 0 -45z m150 0
c0 -24 -3 -25 -60 -25 -57 0 -60 1 -60 25 0 24 3 25 60 25 57 0 60 -1 60 -25z" />
<path d="M7055 15100 c-13 -5 22 -8 95 -8 72 0 106 3 90 8 -34 11 -160 11
-185 0z" />
<path d="M7075 15049 c18 -5 43 -5 60 0 25 8 20 9 -30 9 -51 0 -55 -1 -30 -9z" />
<path d="M5025 15520 c-4 -6 10 -10 34 -10 23 0 41 5 41 10 0 6 -15 10 -34 10
-19 0 -38 -4 -41 -10z" fill="orange"/>
<path d="M9278 15523 l-28 -4 -1 -107 c-2 -217 3 -337 14 -344 16 -10 389 -10
405 1 10 6 13 58 13 226 0 119 -3 220 -6 224 -8 7 -357 11 -397 4z m332 -168
l0 -95 -145 0 -145 0 0 95 0 95 145 0 145 0 0 -95z" />
<path d="M9342 15403 c2 -17 9 -28 18 -28 9 0 16 11 18 28 3 22 -1 27 -18 27
-17 0 -21 -5 -18 -27z" />
<path d="M9392 15403 c2 -17 10 -29 21 -31 13 -3 17 3 17 27 0 25 -4 31 -21
31 -16 0 -20 -5 -17 -27z" />
<path d="M9452 15405 c2 -14 8 -26 13 -26 6 0 11 12 13 26 2 18 -1 25 -13 25
-12 0 -15 -7 -13 -25z" />
<path d="M9502 15403 c2 -17 9 -28 18 -28 9 0 16 11 18 28 3 22 -1 27 -18 27
-17 0 -21 -5 -18 -27z" />
<path d="M9552 15403 c2 -17 10 -29 21 -31 13 -3 17 3 17 27 0 25 -4 31 -21
31 -16 0 -20 -5 -17 -27z" />
<path d="M9345 15331 c-16 -15 22 -21 128 -19 67 1 104 3 82 6 -32 3 -36 6
-20 12 12 5 -23 8 -83 7 -57 -1 -105 -3 -107 -6z" />
<path d="M9460 15280 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
<path d="M4990 15410 c0 -5 13 -16 29 -25 35 -18 54 -2 25 20 -22 17 -54 20
-54 5z" fill="orange"/>

<path d="M7663 15284 c-3 -8 -1 -20 4 -25 5 -5 291 -8 734 -7 716 3 724 3 724
23 0 20 -8 20 -728 23 -654 2 -728 1 -734 -14z" fill={arrowColor}/>


<path d="M9774 15285 c-3 -8 -3 -19 1 -25 4 -7 180 -10 546 -10 l539 0 0 -322
0 -322 -59 58 c-40 40 -65 57 -75 53 -28 -11 -17 -31 59 -107 l75 -74 0 -263
0 -263 -517 -2 c-510 -3 -518 -3 -518 -23 0 -20 8 -20 545 -23 l545 -2 -3 260
c-4 300 -6 293 82 380 47 45 56 60 56 89 l0 35 -70 -69 -70 -69 0 357 0 357
-565 0 c-485 0 -566 -2 -571 -15z" fill={arrowColor}/>
<path d="M5133 15244 c-3 -8 -1 -20 4 -25 5 -5 307 -8 774 -7 756 3 764 3 764
23 0 20 -8 20 -768 23 -690 2 -768 1 -774 -14z" fill={arrowColor}/>
<path d="M9357 15044 c-13 -13 -7 -34 9 -34 13 0 14 -3 4 -15 -15 -18 -6 -45
14 -45 18 0 29 42 13 52 -8 5 -6 8 6 8 29 0 16 34 -13 38 -14 2 -29 0 -33 -4z" />
<path d="M9430 15030 c0 -11 6 -20 13 -20 9 0 12 -10 9 -30 -3 -23 -1 -30 13
-30 14 0 16 7 13 30 -3 20 0 30 9 30 7 0 13 9 13 20 0 16 -7 20 -35 20 -28 0
-35 -4 -35 -20z" />
<path d="M9517 15044 c-12 -12 -8 -34 6 -34 9 0 12 -10 9 -31 -4 -26 -2 -30
14 -27 23 4 31 37 12 49 -10 7 -9 9 5 9 29 0 16 34 -13 38 -14 2 -29 0 -33 -4z" />
<path d="M4536 14358 c-9 -12 -25 -51 -37 -85 -16 -51 -35 -79 -89 -137 -69
-75 -96 -113 -86 -123 3 -3 12 -1 19 5 10 9 17 8 26 -1 11 -9 14 -9 18 1 3 6
16 12 29 12 13 0 24 5 24 10 0 6 -16 10 -35 10 -19 0 -35 4 -35 9 0 5 21 28
48 52 l47 44 3 -63 3 -63 -76 -85 c-41 -47 -75 -92 -75 -101 0 -14 3 -14 21 3
17 15 22 16 29 4 7 -12 12 -12 22 -2 6 6 20 12 31 12 10 0 15 5 12 10 -3 6
-20 10 -38 10 l-31 0 44 45 c24 25 48 45 53 45 5 0 7 -33 5 -72 -3 -56 -14
-100 -47 -185 l-43 -112 -62 -4 c-33 -2 79 -3 249 -3 171 -1 283 2 251 5 l-59
6 -42 110 c-43 112 -63 218 -45 245 8 12 18 7 57 -32 l48 -48 -38 0 c-20 0
-37 -4 -37 -10 0 -5 6 -10 14 -10 7 0 19 -7 26 -15 11 -13 14 -13 26 2 12 17
14 17 28 -2 l15 -20 1 20 c0 11 -31 54 -68 95 -72 79 -88 117 -75 182 l6 29
43 -42 c50 -49 54 -59 21 -59 -35 0 -40 -11 -11 -27 20 -10 30 -10 40 -2 11 9
18 8 29 -1 12 -10 15 -9 15 7 0 11 -35 58 -78 105 -62 68 -82 98 -101 152 -34
97 -63 119 -95 74z m73 -70 c30 -89 30 -88 -38 -88 -33 0 -62 4 -65 9 -5 8 25
108 39 131 3 6 15 10 25 10 13 0 24 -16 39 -62z m1 -115 c0 -4 -10 -17 -22
-30 l-22 -23 -23 22 c-33 31 -29 38 22 38 25 0 45 -3 45 -7z m-87 -96 l-28
-29 -3 37 c-2 21 -1 44 3 53 5 13 10 11 30 -8 l25 -24 -27 -29z m117 21 l0
-53 -27 27 -27 27 24 26 c13 14 25 25 27 25 2 0 3 -24 3 -52z m-48 -35 c28
-25 22 -33 -29 -33 l-46 0 23 25 c28 30 28 30 52 8z m-2 -88 c-21 -22 -26 -24
-44 -12 -37 25 -31 37 20 37 l47 0 -23 -25z m-63 -27 l23 -22 -22 -23 c-31
-33 -38 -29 -38 22 0 25 3 45 7 45 4 0 17 -10 30 -22z m113 -23 c0 -43 -1 -45
-21 -35 -29 16 -34 38 -14 60 27 30 35 24 35 -25z m-39 -46 c37 -26 36 -38 -4
-77 l-33 -32 -34 35 -34 35 29 30 c34 36 38 36 76 9z m-78 -96 l26 -28 -70
-74 c-38 -41 -71 -72 -74 -69 -8 8 73 198 85 198 3 0 18 -12 33 -27z m166 -61
c19 -46 31 -85 27 -89 -6 -7 -126 105 -126 118 0 14 43 60 54 56 6 -2 26 -40
45 -85z m-36 -70 l38 -39 -77 -6 c-42 -4 -100 -7 -128 -7 l-50 0 63 64 64 65
26 -19 c14 -10 43 -36 64 -58z" />
<path d="M7155 14230 l-100 -5 -3 -205 c-1 -113 0 -215 3 -227 5 -23 6 -23
211 -23 185 0 205 2 212 18 8 19 10 428 2 435 -8 8 -218 12 -325 7z m255 -97
c0 -16 3 -58 7 -95 l6 -68 -152 0 -151 0 0 95 0 95 145 0 145 0 0 -27z" />
<path d="M7140 14110 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30
-16 0 -20 -7 -20 -30z" />
<path d="M7194 14126 c-9 -24 4 -48 23 -44 12 2 18 12 18 28 0 29 -32 41 -41
16z" />
<path d="M7250 14110 c0 -20 5 -30 15 -30 10 0 15 10 15 30 0 20 -5 30 -15 30
-10 0 -15 -10 -15 -30z" />
<path d="M7300 14110 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30
-16 0 -20 -7 -20 -30z" />
<path d="M7354 14126 c-9 -24 4 -48 23 -44 12 2 18 12 18 28 0 29 -32 41 -41
16z" />
<path d="M7153 14043 c-39 -15 1 -23 115 -21 93 1 112 3 72 8 -51 5 -52 6 -20
11 19 3 -8 6 -60 7 -52 0 -101 -2 -107 -5z m90 -10 c-13 -2 -33 -2 -45 0 -13
2 -3 4 22 4 25 0 35 -2 23 -4z" />
<path d="M9306 14224 c-3 -9 -6 -107 -6 -219 0 -192 1 -205 19 -215 12 -6 96
-10 205 -10 154 0 187 3 200 16 14 13 16 47 16 214 0 109 -3 205 -6 214 -5 14
-34 16 -214 16 -180 0 -209 -2 -214 -16z m362 -151 l3 -93 -151 0 -150 0 0 95
0 96 148 -3 147 -3 3 -92z" />
<path d="M9392 14123 c2 -17 10 -29 21 -31 13 -3 17 3 17 27 0 25 -4 31 -21
31 -16 0 -20 -5 -17 -27z" />



<path d="M9450 14119 c0 -24 4 -30 18 -27 10 2 18 14 20 31 3 22 -1 27 -17 27
-17 0 -21 -6 -21 -31z" />
<path d="M9504 14136 c-8 -22 3 -49 19 -43 6 2 12 14 12 27 0 27 -22 39 -31
16z" />
<path d="M9552 14123 c2 -17 10 -29 21 -31 13 -3 17 3 17 27 0 25 -4 31 -21
31 -16 0 -20 -5 -17 -27z" />
<path d="M9610 14119 c0 -24 4 -30 18 -27 10 2 18 14 20 31 3 22 -1 27 -17 27
-17 0 -21 -6 -21 -31z" />
<path d="M9402 14053 c-36 -14 12 -23 121 -21 97 1 110 3 62 8 -58 6 -59 6
-20 11 23 3 1 6 -55 7 -52 0 -101 -2 -108 -5z m101 -10 c-13 -2 -35 -2 -50 0
-16 2 -5 4 22 4 28 0 40 -2 28 -4z" />
<path d="M9510 14000 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
<path d="M5181 14071 c-39 -44 -71 -84 -71 -89 0 -15 170 -157 188 -157 36 0
21 33 -40 86 l-62 54 804 5 c797 5 805 5 805 25 0 20 -8 20 -797 25 l-798 5
41 48 c40 46 46 77 16 77 -8 0 -46 -36 -86 -79z" fill={arrowColor}/>
<path d="M7743 14014 c-3 -8 -1 -20 4 -25 5 -5 286 -8 719 -7 701 3 709 3 709
23 0 20 -8 20 -713 23 -641 2 -713 1 -719 -14z" fill={arrowColor}/>
<path d="M9417 13764 c-17 -17 -5 -34 24 -34 24 0 30 4 27 18 -3 17 -38 29
-51 16z"/>
<path d="M9485 13760 c-11 -18 10 -32 41 -28 40 4 38 32 -3 36 -17 2 -34 -2
-38 -8z"/>
<path d="M9577 13764 c-17 -17 -5 -34 24 -34 24 0 30 4 27 18 -3 17 -38 29
-51 16z"/>
<path d="M7161 13751 c-21 -13 -4 -31 30 -31 31 0 41 23 13 34 -20 8 -26 7
-43 -3z"/>
<path d="M7243 13753 c-7 -2 -13 -11 -13 -18 0 -10 19 -14 75 -13 56 0 75 3
75 13 0 19 -35 28 -58 16 -11 -6 -24 -6 -33 0 -15 9 -27 10 -46 2z"/>
<path d="M9420 13694 c0 -33 33 -30 38 4 3 17 -2 22 -17 22 -16 0 -21 -6 -21
-26z"/>
<path d="M9500 13695 c0 -18 5 -25 20 -25 15 0 20 7 20 25 0 18 -5 25 -20 25
-15 0 -20 -7 -20 -25z"/>
<path d="M9582 13698 c5 -34 38 -37 38 -4 0 20 -5 26 -21 26 -15 0 -20 -5 -17
-22z"/>
<path d="M7170 13685 c0 -28 24 -34 34 -9 10 26 7 34 -14 34 -15 0 -20 -7 -20
-25z"/>
<path d="M7250 13685 c0 -16 6 -25 15 -25 9 0 15 9 15 25 0 16 -6 25 -15 25
-9 0 -15 -9 -15 -25z"/>
<path d="M7330 13685 c0 -18 5 -25 20 -25 15 0 20 7 20 25 0 18 -5 25 -20 25
-15 0 -20 -7 -20 -25z"/>
</g>
</svg>
    </div>
  );
};

export default LtSvg;
